import {useContext} from "react";
import {FileTypes, KindOfOrder} from "../../../../types/enums";
import {FileAttachmentsButton} from "../../../common";
import {EstimateContext, RefetchScope} from "../context/EstimateContext";

export default function EstimateFilesButton(props: { defaultFileType?: FileTypes }) {

	const { order, refetchOrder } = useContext(EstimateContext);

	return (
		<FileAttachmentsButton
			attachedFiles={order.details.files}
			orderID={order.details.quoteID}
			parentGuid={order.details.guid}
			kindOfOrder={KindOfOrder.Estimate}
			defaultFileType={props.defaultFileType}
			useFileTypes={false}
			onFileAdded={() => refetchOrder(RefetchScope.Files)}
			onFileDeleted={() => refetchOrder(RefetchScope.Files)}
		/>
	)
}
